// numberUtilsMixin.js
export const numberUtilsMixin = {
  methods: {

    // 向下取整到 0 或 数量级
    roundDown(min, max) {
      if (min >= 0) return 0
      min = parseFloat(min) * 1.15
      // 计算数量级
      const magnitude = min < -1 ? 1 : Math.floor(Math.log10(Math.abs(min)))
      const precision = Math.pow(10, magnitude)
      let minLabel = Math.floor(min / precision) * precision
      return magnitude >= 0 ? minLabel : minLabel.toFixed(Math.abs(magnitude))
    },

    // 向上取整到数量级
    roundUp(min, max) {
      if (max == 0 && min == 0) return 1
      else if (max == 0 && min <= 0) return 0
      max = max >= 0 ? parseFloat(max) * 1.15 : parseFloat(max) * 0.85
      // 计算数量级
      const magnitude = max > 1 ? 1 : Math.floor(Math.log10(Math.abs(max)))
      const precision = Math.pow(10, magnitude)
      let maxLabel = Math.ceil(max / precision) * precision
      return magnitude >= 0 ? maxLabel : maxLabel.toFixed(Math.abs(magnitude))
    },

    //下截断（floor）到小数点后 数量级 位。
    truncateTo2Decimals(value) {
      const num = Number(value)
      if (!Number.isFinite(num)) return value
      let magnitude =  Math.floor(Math.log10(Math.abs(num)))
      if(magnitude >= -2) return Math.floor(num * 100) / 100
      else return Math.floor(num * Math.pow(10,Math.abs(magnitude))) / Math.pow(10,Math.abs(magnitude))
    },

    /**
     *
     * @param target 目标值
     * @param xData 数组
     */
    binarySearch(target, xData) {
      let left = 0, right = xData.length - 1;

      while (left <= right) {
        let mid = Math.floor((left + right) / 2);

        if (xData[mid] === target) {
          return mid;
        }

        if (xData[mid] < target) {
          left = mid + 1;
        } else {
          right = mid - 1;
        }
      }

      // 循环结束后，left 是比 target 大的第一个元素下标
      // right 是比 target 小的最后一个元素下标
      if (left >= xData.length) return xData.length - 1;
      if (right < 0) return 0;

      // 选距离更近的一个
      return (target - xData[right] <= xData[left] - target) ? right : left;
    },

    //轴心轨迹-放大同步使用
    binarySearch2(target, xData, preferSide = 1) {
      let left = 0, right = xData.length - 1;

      while (left <= right) {
        let mid = Math.floor((left + right) / 2);

        if (xData[mid] === target) {
          return mid;
        }

        if (xData[mid] < target) {
          left = mid + 1;
        } else {
          right = mid - 1;
        }
      }

      // 循环结束后，left 是比 target 大的第一个元素下标
      // right 是比 target 小的最后一个元素下标
      if (left >= xData.length) return xData.length - 1;
      if (right < 0) return 0;
      return preferSide === 0 ? left : right;
    },


    /**
     *
     * @param num
     * @param decimalPlaces 小数位数
     * @returns {number}
     */
    roundToDecimalPlaces(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      const rounded = Math.round((num + Number.EPSILON) * factor) / factor;
      return rounded.toFixed(decimalPlaces); // 返回字符串，自动补0
    },
    /**
     * 生成包含绝对边界和最大数量级步长的坐标轴刻度数组
     * @param {number} min - 最小值
     * @param {number} max - 最大值
     * @param {number} splitNumber - 期望的网格分段数 (默认 6)
     * @returns {number[]} 刻度数组
     */
    getSmartTicks(min, max, splitNumber = 6) {
      if (min === max) return [min];
      const range = max - min;
      const roughStep = range / splitNumber;
      const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
      const normalizedStep = roughStep / magnitude;

      let step;
      if (normalizedStep < 1.5) step = 1 * magnitude;
      else if (normalizedStep < 2.5) step = 2 * magnitude;
      else if (normalizedStep < 3.5) step = 3 * magnitude;
      else if (normalizedStep < 7.5) step = 5 * magnitude;
      else step = 10 * magnitude;

      const ticks = [];
      ticks.push(min);

      const epsilon = 1e-10;
      let currentTick = Math.ceil((min + epsilon) / step) * step;
      currentTick = Number(currentTick.toFixed(10));
      while (currentTick < max - epsilon) {
        if (Math.abs(currentTick - min) > epsilon) {
          ticks.push(currentTick === 0 ? 0 : currentTick);
        }
        currentTick += step;
        currentTick = Number(currentTick.toFixed(10));
      }
      if (Math.abs(ticks[ticks.length - 1] - max) > epsilon) {
        ticks.push(max);
      }
      return ticks;
    },
    /**
     * 计算图表自适应的智能上界 (规整且不超过 15% 留白)
     * @param {number} maxZ 数据的真实最大值
     * @returns {number} 完美的封顶高度
     */
    getSmartUpperBound(maxZ) {
      if (maxZ === 0) return 1;

      // 允许的极限范围：最少留 2% 空隙防止波峰贴顶，最多留 15% 防止大块留白
      const minLimit = maxZ * 1.02;
      const maxLimit = maxZ * 1.15;
      // 计算数量级 (例如 20.2 -> 10, 0.48 -> 0.1)
      const magnitude = Math.pow(10, Math.floor(Math.log10(maxZ)));
      const niceSteps = [
        10, 5, 4, 2.5, 2,
        1, 0.5, 0.4, 0.25, 0.2,
        0.1, 0.05, 0.04, 0.025, 0.02, 0.01
      ];

      for (let i = 0; i < niceSteps.length; i++) {
        const step = niceSteps[i] * magnitude;
        let candidate = Math.ceil(maxZ / step) * step;
        // 如果取整后刚好等于 maxZ，或者贴得太紧（小于 2% 留白），则强行增加一个步长
        if (candidate < minLimit) {
          candidate += step;
        }
        if (candidate <= maxLimit) {
          return Number(candidate.toFixed(6));
        }
      }
      return Number((maxZ * 1.10).toFixed(6));
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/numberUtilsMixin.js